import { Theme } from "@mui/material";

export const getMiscOverrides = (theme: Theme) => ({
  MuiCssBaseline: {
    styleOverrides: {
      "*": {
        "&::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: theme.palette.mode === "dark" ? theme.palette.primary.light : "#c1c1c1",
          borderRadius: "4px",
          border: theme.palette.mode === "dark" ? "1px solid rgba(255,255,255,0.3)" : "1px solid transparent",
          "&:hover": {
            backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.8)" : "#a8a8a8",
          },
          "&:active": {
             backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.9)" : "#909090",
          },
        },
        "&::-webkit-scrollbar-corner": {
          backgroundColor: "transparent",
        },
         ...(theme.palette.mode === "dark" && {
            // Dark mode global fieldset overrides
             fieldset: {
                borderColor: "rgba(255, 255, 255, 0.23) !important",
              },
              "fieldset:hover": {
                borderColor: "#FFFFFF !important",
              },
              "fieldset.Mui-focused": {
                borderColor: `${theme.palette.highlight} !important`,
              },
              "fieldset.Mui-disabled": {
                borderColor: "rgba(255, 255, 255, 0.12) !important",
              },
          }),
      },
    },
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        color: theme.palette.highlight,
         ...(theme.palette.mode === "dark" && {
             "&.Mui-disabled": {
              color: theme.palette.highlight,
            },
         }),
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        color: theme.palette.mode === "dark" ? theme.palette.text.secondary : "#4A4A4A",
        "&.Mui-selected": {
          color: theme.palette.mode === "dark" ? "#FFFFFF" : theme.palette.highlight,
          fontWeight: 600,
        },
        indicator: {
          backgroundColor: theme.palette.mode === "dark" ? "#FFFFFF" : "red",
          height: "1px",
          borderRadius: "2px",
        },
      },
    },
  },
    MuiSwitch: {
    styleOverrides: {
      root: {
        "& .MuiSwitch-track": {
          backgroundColor: "#6e6e6eff",
          opacity: 1,
        },
        "& .Mui-checked": {
          "& + .MuiSwitch-track": {
            backgroundColor: `${theme.palette.mode === "dark" ? theme.palette.success.main : theme.palette.success.light} !important`,
            opacity: 1,
          },
        },
        "& .MuiSwitch-thumb": {
          height: 18,
          width: 18,
           boxShadow: theme.palette.mode === "dark" ? "0 0 4px #ffffffff" : "0 0 4px #6c6c6cff",
        },
        "& .MuiSwitch-switchBase": {
          color: theme.palette.mode === "dark" ? "#292929ff" : "#ffffffff",
        },
      },
    },
  },
});
